import {
    buildComponentSlice,
    useComponentSlice,
    WidgetComponentSliceActionPayloadType,
} from 'widgets/store/component/componentSlice';

import { WidgetType } from 'widgets/WidgetType';
import {
    initialVenueAnalysisComponentState,
    VenueAnalysisComponentState,
} from './VenueAnalysisComponentState';
import { selectVenueAnalysisState } from '../selectors';

export const buildVenueAnalysisComponentSlice = () =>
    buildComponentSlice<VenueAnalysisComponentState>(
        WidgetType.VENUE_ANALYSIS,
        selectVenueAnalysisState,
        initialVenueAnalysisComponentState
    );

export const useVenueAnalysisComponentSlice = () =>
    useComponentSlice(buildVenueAnalysisComponentSlice());

export type VenueAnalysisComponentPayloadType =
    WidgetComponentSliceActionPayloadType<VenueAnalysisComponentState>;
